import React, {useEffect, useState, useRef} from 'react';
import Axios from 'axios';
import { Alert } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import '../App.css';
import Pagination from '../components/global/Paginator'
import {exportToExcel} from "../utils/reports/exportToExcel";
import {formatDate} from "../utils/dates";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFileExcel} from "@fortawesome/free-solid-svg-icons";
import userImage from "../media/account-user-group-people-person-profile-svgrepo-com.svg"

function Grillabotxusersreport (props){
    const fileInputRef = useRef();
    const searchInput = useRef(null);
    const [show, setShow] = useState(false);
    const [datos, setDatos] = useState([]);
    const [datosDetalle, setDatosDetalle] = useState([]);
    const [datosBackup, setDatosBackup] = useState([])
    const [metaData, setMetaData] = useState([])
    const [datosExport, setDatosExport] = useState([]);
    const [idcasino, setIdCasino] = useState();


    const [direccioncasino, setDireccionCasino] = useState()
    const [valorticketcasino, setValorTicketCasino] = useState()
    const [fecha, setFecha] = useState('')
    const [visible, setVisible] = useState('seccionNoVisible')
    const [beneficiariobyuser, setBeneficiariobyuser] = useState([])
    const [beneficiario, setBeneficiario] = useState()
    const [ticketid, setTicketId] = useState()
    const [user, setUser] = useState()
    const [tituloAlert, setTituloAlert] = useState('')
    const [textoAlert, setTextoAlert] = useState('')
    const [claseAlert, setClaseAlert] = useState('')
    const [alert, setAlert] = useState(false);


    const [fechaInicio, setFechaInicio] = useState('')
    const [usuario, setUsuario] = useState('')
    const [fechafinal, setFechaFinal] = useState('')
    const [file, setFile] = useState('');
    const [fileName, setFileName] = useState("");
    const [barcoderest, setBarcoderest] = useState('')
    const [pageNumber, setPageNumber] = useState('')
    const [pageSize, setPageSize] = useState(3);
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);   
    const [typeUser, setTypeUser] = useState('Apoderado')

    // Referencia para el número de página (evitar estados desincronizados)
    const pageRef = useRef(currentPage);
 

    let statuscall = '' 
    
    const dataList = datos.map((item, i) => 
        <div key={i} className="bg-gray-200 p-6 rounded-lg shadow-md mt-6">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">Detalle Transaccion</h3>
        
        {/* Contenedor con grid de 4 columnas, en pantallas grandes */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        
        {/* Columna 1 */}
        <div className="space-y-2">
            {/* Número de Índice - destacado */}
            <div className="flex justify-end">
            <span className="bg-indigo-600 text-white px-3 py-1 rounded-lg text-xl font-bold">Nº {i + 1}</span>
            </div>

            {/* Email Usuario */}
            <div className="flex justify-start">
            <span className="font-medium text-gray-500">Nº Transaccion:</span>
            <span className="font-semibold text-gray-800">{item.numero_transaccion}</span>
            </div>
        </div>

        {/* Columna 2 */}
        <div className="space-y-2">
            {/* Total Saldo */}
            <div className="flex justify-start">
            <span className="font-medium text-gray-500">Estado:</span>
            <span className="font-semibold text-gray-800">{item.estado}</span>
            </div>

            {/* Boton Detalle Saldo */}
            <div className="flex justify-start">
            <span className="font-medium text-gray-500">Codigo autorizacion:</span>
            <span className="font-semibold text-gray-800">{item.codigo_autorizacion}</span>
            </div>
            {/* Total Saldo */}
            <div className="flex justify-start">
            <span className="font-medium text-gray-500">Tipo de pago:</span>
            <span className="font-semibold text-gray-800">{item.tipo_pago}</span>
            </div>
        </div>

        <div className="space-y-2">
            {/* Total Saldo */}
            <div className="flex justify-start">
            <span className="font-medium text-gray-500">Cantidad producto:</span>
            <span className="font-semibold text-gray-800">{item.cantidad_producto}</span>
            </div>

            {/* Boton Detalle Saldo */}
            <div className="flex justify-start">
            <span className="font-medium text-gray-500">Tickets generados:</span>
            <span className="font-semibold text-gray-800">{item.tickets_generados}</span>
            </div>

            {/* Boton Detalle Saldo */}
            <div className="flex justify-start">
            <span className="font-medium text-gray-500 justify-end">Digitos tarjeta:</span>
            <span className="font-semibold text-gray-800 justify-start">{item.ultimos_digitos_tarjeta}</span>
            </div>

            {/* Boton Detalle Saldo */}
            <div className="flex justify-start">
            <span className="font-medium text-gray-500 justify-end">Monto:</span>
            <span className="font-semibold text-gray-800 justify-start">{item.monto}</span>
            </div>
        </div>

        <div className="space-y-2">
            {/* Total Saldo */}
            <div className="flex justify-start">
            <span className="font-medium text-gray-500">Fecha contable:</span>
            <span className="font-semibold text-gray-800">{item.fecha_contable}</span>
            </div>

            {/* Boton Detalle Saldo */}
            <div className="flex justify-start">
            <span className="font-medium text-gray-500">Fecha creacion:</span>
            <span className="font-semibold text-gray-800">{item.fecha_creacion}</span>
            </div>

            {/* Boton Detalle Saldo */}
            <div className="flex justify-start">
            <span className="font-medium text-gray-500">Fecha modificacion:</span>
            <span className="font-semibold text-gray-800">{item.fecha_creacion}</span>
            </div>

        </div>

        </div>
    </div>);


    const GetTicket = () => {
        const date = new Date();
        let usuario = window.localStorage.getItem('MY_APP_STATE_USER').replace('"', '')
        const formattedDate = date.toISOString().split('T')[0];
        Axios.get(process.env.REACT_APP_URLTICKETUSERSTXWALLETREPORT, {
            params: {
                page: pageNumber || 1,
                pageSize: pageSize || 10,
                fechaInicio: fechaInicio || formattedDate,
                fechaFin: fechafinal || formattedDate,                                
                usuario: usuario.replace('"', '')               
            }, 
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setDatos(response.data.transacciones)
            setDatosBackup(response.data.transacciones)
            setMetaData(response.data.transacciones_metadata)

            setCurrentPage(response.data.transacciones_metadata.currentPage)
            setPageNumber(response.data.transacciones_metadata.currentPage)
            setTotalPages(response.data.transacciones_metadata.totalPages)
        }).catch(error => {
            return error     
        });
    };



      

    const handlePageSize = (e) => {
        setPageSize(e.target.value)
    }

    const handleFechaInicio = (e) => {
        setFechaInicio(e.target.value)
    }

    const handleFechaFinal = (e) => {
        setFechaFinal(e.target.value)
    }


    useEffect(() => {
        GetTicket()

    }, [pageNumber]);


    const handleClose = () => {
        setBeneficiario('')
        setFecha('')
        setShow(false)
    }
    const handleShow = () => setShow(true)

    const handleChangeList= (e) => {
        let text = e.target.value;
        const setBusqueda = e.target.value;
        const data = datosBackup
        const newData = data.filter(
            function(item){
                const itemDataUsuario = item.user_id
                const campo = itemDataUsuario
                const textData = text.toUpperCase()
                return campo.indexOf(textData) > -1        
            }
        )
        setDatos(newData)
    }


    const handleTypeUser = (e) => {
        setTypeUser(e.target.value)
    }



    return(
    <div className='w-full'>
        {/* Zona 1 - Filtros */}
        <div className="bg-white shadow-lg p-6 mx-4 mb-2">
            <h2 className="text-xl font-semibold mb-4">Filtros de Reporte de transacciones billetera</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">

                {/* Campo Fecha Inicio */}
                <div className="flex flex-col">
                    <label htmlFor="fechaInicio" className="text-sm font-medium text-gray-600 mb-1">Fecha Inicio</label>
                    <input
                    value={fechaInicio} 
                    onChange={handleFechaInicio}
                    type="date" 
                    id="fechaInicio" 
                    className="p-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500" 
                    />
                </div>

                {/* Campo Fecha Fin */}
                <div className="flex flex-col">
                    <label htmlFor="fechaFin" className="text-sm font-medium text-gray-600 mb-1">Fecha Fin</label>
                    <input
                    value={fechafinal} 
                    onChange={handleFechaFinal}
                    type="date" 
                    id="fechaFin" 
                    className="p-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500" 
                    />
                </div>

                {/* Campo Selección Número de Páginas */}
                <div className="flex flex-col">
                    <label htmlFor="numeroPaginas" className="text-sm font-medium text-gray-600 mb-1">Número de Páginas</label>
                    <input 
                    type="number" 
                    id="numeroPaginas"
                    value={pageSize}
                    onChange={handlePageSize} 
                    min="1" 
                    step="1" 
                    defaultValue="1" 
                    className="p-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500" 
                    />
                </div>

                {/* Botón Generar Reporte con Icono */}
                <div className="flex flex-col justify-end w-full sm:w-auto">
                <button onClick={GetTicket} className="w-full bg-indigo-600 text-white p-2 text-sm rounded-lg shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 flex items-center justify-center space-x-2">
                    {/* Icono de Reporte */}
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="h-5 w-5 mr-2">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8h2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h2M15 3h-6a2 2 0 0 0-2 2v4h10V5a2 2 0 0 0-2-2z" />
                    </svg>
                    {/* Texto del Botón */}
                    Generar Reporte
                </button>
                </div>

                </div>
        </div>


        {/* Zona 2 */}
        <div className="bg-white shadow-lg p-4  mx-4 mb-2">
            {/* Controles de Búsqueda y Exportar */}
            <div className="flex justify-between items-center mb-4">
                        {/* Campo de Búsqueda */}
                        <div className="flex flex-col col-span-1 sm:col-span-2 lg:col-span-1">
                            
                            <div className="flex items-center bg-gray-100 border border-gray-300 rounded-lg">
                            <input 
                                type="search" 
                                id="search"
                                onChange={handleChangeList} 
                                placeholder="Buscar en grilla" 
                                className="p-2 text-sm bg-transparent border-0 outline-none flex-1 rounded-l-lg focus:ring-0" 
                            />
                            <button className="p-2 text-gray-500 bg-transparent rounded-r-lg hover:bg-gray-200">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="h-5 w-5">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8zm0 0l5 5" />
                                </svg>
                            </button>
                            </div>
                        </div>
            </div>
            <div className="overflow-y-auto h-[600px] p-4">
                {/* Contenedor para los detalles de los tickets */}
                <div className="space-y-6">
                    {dataList}
                </div>
            </div>
            <div className="w-full mt-4 flex justify-center">
                <Pagination currentPage={pageNumber} totalPages={totalPages} onPageChange={setPageNumber}/>
            </div>
        </div>                                                                                                                                                                                           
    </div>    
    )
}
export default Grillabotxusersreport